import { useEffect, useState, useCallback } from "react";
import API_URL from "../config";

export default function Carousel() {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/slides`)
      .then(res => res.json())
      .then(data => { setSlides(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % slides.length);
  }, [slides.length]);

  const prev = () => {
    setCurrent(prev => (prev - 1 + slides.length) % slides.length);
  };

  // Défilement automatique toutes les 5 secondes
  useEffect(() => {
    if (slides.length === 0) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [slides.length, next]);

  if (loading) return (
    <div className="w-full h-[260px] md:h-[520px] bg-gray-100 animate-pulse" />
  );

  if (slides.length === 0) return null;

  return (
    <div className="relative w-full h-[260px] md:h-[520px] overflow-hidden bg-black group">

      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={slide._id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
        >
          {/* Image */}
          <img
            src={slide.imageUrl}
            alt={slide.titre}
            className="w-full h-full object-cover"
          />

          {/* Overlay dégradé */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

          {/* Texte */}
          <div className="absolute bottom-16 left-0 right-0 text-center px-8">
            <h2 className="text-white text-4xl font-semibold mb-3 drop-shadow-lg">
                {slide.titre}
            </h2>
                {slide.description && (
                <p className="text-white/80 text-lg max-w-2xl mx-auto drop-shadow">
                {slide.description}
            </p>
                )}
            </div>
        </div>
      ))}

      {/* Bouton précédent */}
      <button
        onClick={prev}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white w-10 h-10 rounded-full flex items-center justify-center backdrop-blur-sm transition opacity-0 group-hover:opacity-100"
      >
        ‹
      </button>

      {/* Bouton suivant */}
      <button
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white w-10 h-10 rounded-full flex items-center justify-center backdrop-blur-sm transition opacity-0 group-hover:opacity-100"
      >
        ›
      </button>

      {/* Indicateurs */}
      <div className="absolute bottom-5 left-0 right-0 flex justify-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === current
                ? "bg-white w-6"
                : "bg-white/50 hover:bg-white/75"
            }`}
          />
        ))}
      </div>

    </div>
  );
}